import { useEffect, useState } from "react";
import { Building2, BadgeCheck, Heart, Users } from "lucide-react";
import { fetchCompany } from "@/lib/api";

export const AboutCompany = () => {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    fetchCompany().then(setCompany).catch(() => setCompany(null));
  }, []);

  if (!company) return null;
  const sinceYear = company.date_of_incorporation?.split("/")?.[2] || "2017";

  const stats = [
    { icon: Heart, label: "Pediatric specialised", value: "100%" },
    { icon: Users, label: "Operating since", value: sinceYear },
    { icon: BadgeCheck, label: "Enterprise type", value: company.enterprise_type },
    { icon: Building2, label: "Constitution", value: company.constitution },
  ];

  return (
    <section
      id="about"
      data-testid="about-company-section"
      className="py-20 sm:py-28 bg-secondary/40"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold tracking-widest uppercase text-primary">
            About the Company
          </p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-foreground leading-tight">
            Built on trust,
            <span className="gradient-text-blue"> caring for the next generation.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
            <strong className="text-foreground">{company.trade_name}</strong> is a
            pharmaceutical trading enterprise based in Greater Noida, Uttar Pradesh.
            Operating since {sinceYear}, we specialise in the pediatric segment with
            a focused portfolio that brings quality and accessibility together — for
            paediatricians, parents and pharmacies across India.
          </p>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map(({ icon: Icon, label, value }) => (
            <div
              key={label}
              className="bg-white border border-border rounded-2xl p-6 soft-shadow"
              data-testid={`about-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="w-10 h-10 rounded-xl bg-secondary text-primary grid place-items-center mb-3">
                <Icon className="w-5 h-5" />
              </span>
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">
                {label}
              </p>
              <p className="font-heading font-bold text-foreground mt-1 text-lg">
                {value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;
